module.exports = __webpack_public_path__ + "img/leftthigh-endo-mesomorph-female.186400bd.svg";